var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { MapGetters, MapState } from 'store/decorators';
import { BookingSources, RefundTypes, RefundReasons, SupportedLanguages } from 'interfaces/PaymentForm';
import BookingCancelationHttpService from 'services/AirBaltic/Forms/BookingCancelationHttp';
import BookingCancelationService from 'services/AirBaltic/BookingCancelation';
import BookingCancelationValidationService from 'services/AirBaltic/Forms/BookingCancelationValidation';
import ButtonBlue from 'components/Buttons/Blue.vue';
import CheckboxElement from 'components/Elements/Checkbox.vue';
import DefaultFormNotification from 'components/Notifications/DefaultFormNotification.vue';
import DropdownElement from 'components/Elements/Dropdown.vue';
import FormMixin from 'components/Forms/FormMixin';
import PaymentBaseForm from 'components/Payment/Forms/PaymentBaseForm.vue';
import UuidUtilsService from 'utils/UUID_Utils';
import TranslationUtility from 'services/AirBaltic/TranslationUtility';
import FormHelpers from 'components/Forms/FormHelpers';
import ScrollUtils from 'utils/scrollUtils';
var Errors = function () {
    return import(/* webpackChunkName: "element-errors" */ 'components/Elements/Errors.vue');
};
var BookingCancelationForm = /** @class */ (function (_super) {
    __extends(BookingCancelationForm, _super);
    function BookingCancelationForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refundTypeKey = UuidUtilsService.create_UUID();
        _this.hasAcceptedTermsAndConditions = false;
        _this.childFormError = false;
        _this.form = {
            bookingSource: '',
            refundReason: '',
            refundType: '',
            passengers: [],
            contactFirstName: '',
            contactLastName: '',
            email: '',
            message: '',
            title: '',
            agreeToTerms: false
        };
        return _this;
    }
    BookingCancelationForm.prototype.mounted = function () {
        if (this.isDesktop) {
            return;
        }
        this.scrollToForm();
    };
    Object.defineProperty(BookingCancelationForm.prototype, "isThirdPartyBooking", {
        get: function () {
            return (this.form.bookingSource === BookingSources.THIRD_PARTY &&
                this.form.refundType === RefundTypes.MONEY_VIA_AGENCY);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookingCancelationForm.prototype, "userLanguage", {
        get: function () {
            var selected = this.selectedLang.toUpperCase();
            return Object.keys(SupportedLanguages).includes(selected)
                ? selected
                : SupportedLanguages.EN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookingCancelationForm.prototype, "bookingSources", {
        get: function () {
            return [
                {
                    title: this.$t('payments.bookingSource.airbaltic'),
                    key: BookingSources.AIR_BALTIC,
                    value: BookingSources.AIR_BALTIC
                },
                {
                    title: this.$t('payments.bookingSource.thirdParty'),
                    key: BookingSources.THIRD_PARTY,
                    value: BookingSources.THIRD_PARTY
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookingCancelationForm.prototype, "refundReasons", {
        get: function () {
            return [
                {
                    title: this.$t('payments.refundReason.voluntaryChanges'),
                    key: RefundReasons.VOLUNTARY,
                    value: RefundReasons.VOLUNTARY
                },
                {
                    title: this.$t('payments.refundReason.irregularity'),
                    key: RefundReasons.IRREGULARITY,
                    value: RefundReasons.IRREGULARITY
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookingCancelationForm.prototype, "refundTypes", {
        get: function () {
            return [
                {
                    title: this.$t('reusable.giftCard'),
                    key: RefundTypes.GIFT_CARD,
                    value: RefundTypes.GIFT_CARD
                },
                this.form.bookingSource === BookingSources.THIRD_PARTY
                    ? {
                        title: this.$t('reusable.moneyViaAgency'),
                        key: RefundTypes.MONEY_VIA_AGENCY,
                        value: RefundTypes.MONEY_VIA_AGENCY
                    }
                    : {
                        title: this.$t('reusable.money'),
                        key: RefundTypes.MONEY,
                        value: RefundTypes.MONEY
                    }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookingCancelationForm.prototype, "authorizedText", {
        get: function () {
            return TranslationUtility.splitByPlaceholder(this.$t('payments.bookingCancelation.terms.authorizedToProcess'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookingCancelationForm.prototype, "selectedLang", {
        get: function () {
            return this.main.selectedLang;
        },
        enumerable: false,
        configurable: true
    });
    BookingCancelationForm.prototype.getSelectedValue = function (list, compareValue) {
        var item = list.find(function (_a) {
            var value = _a.value;
            return value === compareValue;
        });
        return item || {};
    };
    BookingCancelationForm.prototype.updateForm = function (form) {
        this.form = __assign(__assign({}, this.form), form);
    };
    BookingCancelationForm.prototype.hasError = function (field) {
        return this.$_formMixin_hasError(this.$v.form, field);
    };
    BookingCancelationForm.prototype.getErrorMsg = function (field) {
        return this.$_formMixin_errorMsg(this.$v.form, BookingCancelationValidationService.errorMessages, field);
    };
    BookingCancelationForm.prototype.scrollToForm = function () {
        var form = this.$refs.cancelationForm;
        if (!form) {
            return;
        }
        ScrollUtils.smoothScroll(form.offsetTop - 50, 300);
    };
    BookingCancelationForm.prototype.scrollToError = function () {
        var _this = this;
        this.$nextTick(function () {
            ;
            _this.$_formHelpers_scrollToError(_this.$el, {
                errorElement: '.error',
                parents: ['.block-input', '.input-block', '.dropdown', '.field-section']
            });
        });
    };
    BookingCancelationForm.prototype.confirm = function () {
        var _this = this;
        var _a, _b;
        this.$v.form.$touch();
        this.$store.dispatch('bookingValidation/validateBookingCancelation');
        var filesValidation = this.$store.getters['bookingValidation/files/validation'];
        if (this.$v.form.$anyError || this.childFormError || (filesValidation === null || filesValidation === void 0 ? void 0 : filesValidation.$invalid)) {
            this.scrollToError();
            return;
        }
        var uploadedFiles = ((_b = (_a = this.$store.state.bookingValidation) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.files) || [];
        var mappedFormData = BookingCancelationService.mapToRequest(this.form, this.$props.bookingRef, this.userLanguage);
        BookingCancelationHttpService.cancelBooking(mappedFormData, uploadedFiles)
            .then(function () { return _this.showSuccessModal(); })
            .catch(function () { return _this.showErrorModal(); });
    };
    BookingCancelationForm.prototype.setBookingSource = function (source) {
        this.form.bookingSource = source.value;
        this.form.refundType = '';
        this.refundTypeKey = UuidUtilsService.create_UUID();
    };
    BookingCancelationForm.prototype.setRefundReason = function (reason) {
        this.form.refundReason = reason.value;
    };
    BookingCancelationForm.prototype.setRefundType = function (type) {
        this.form.refundType = type.value;
    };
    BookingCancelationForm.prototype.openModal = function (props, isSuccess) {
        if (isSuccess === void 0) { isSuccess = false; }
        this.$store.dispatch('main/openModal');
        this.$store.commit('main/setShowModalHeader', false);
        this.$store.commit('main/setShowModalHeaderWhite', false);
        this.$store.commit('main/setModalContent', DefaultFormNotification);
        this.$store.commit('main/setModalType', 'centered');
        this.$store.commit('main/setModalClass', 'modal-white-centered');
        this.$store.commit('main/setShowCloseIcon', true);
        this.$store.commit('main/setShowModalHeader', false);
        this.$store.commit('main/setModalCloseFn', isSuccess ? this.closeOnSuccess : this.closeModal);
        this.$store.commit('main/setModalProps', props);
    };
    BookingCancelationForm.prototype.showSuccessModal = function () {
        var _this = this;
        var props = {
            status: 'success',
            successTitle: this.$t('payments.bookingCancelation.success.title'),
            successMessage: this.$t('payments.bookingCancelation.success.description'),
            showCta: true,
            cta: {
                title: 'buttons.continue',
                action: function () { return _this.closeOnSuccess(); }
            }
        };
        this.openModal(props, true);
    };
    BookingCancelationForm.prototype.showErrorModal = function () {
        var props = {
            status: 'fail',
            failTitle: this.$t('cargoForm.popupMessages.fail.failTitle'),
            showCta: false
        };
        this.openModal(props);
    };
    BookingCancelationForm.prototype.closeModal = function () {
        this.$store.dispatch('main/closeModal');
    };
    BookingCancelationForm.prototype.closeOnSuccess = function () {
        this.closeModal();
        ScrollUtils.smoothScroll(0, 10);
        setTimeout(function () { return window.location.reload(); }, 20);
    };
    __decorate([
        MapState('main')
    ], BookingCancelationForm.prototype, "main", void 0);
    __decorate([
        MapGetters('device', 'isDesktop')
    ], BookingCancelationForm.prototype, "isDesktop", void 0);
    BookingCancelationForm = __decorate([
        Component({
            mixins: [validationMixin, FormMixin, FormHelpers],
            components: {
                ButtonBlue: ButtonBlue,
                CheckboxElement: CheckboxElement,
                DefaultFormNotification: DefaultFormNotification,
                DropdownElement: DropdownElement,
                Errors: Errors,
                PaymentBaseForm: PaymentBaseForm
            },
            props: {
                bookingRef: {
                    type: String,
                    default: ''
                }
            },
            validations: BookingCancelationValidationService.formValidations
        })
    ], BookingCancelationForm);
    return BookingCancelationForm;
}(Vue));
export default BookingCancelationForm;
